const products = {
    products: {
        HaifaStimBooster: "Aumenta la actividad metabólica en situaciones estresantes",
        HaifaStimEnergy: "Mejora el balance energético de la planta",
        HaifaStimForce: "Ahorra energía metabólica: potenciando la síntesis de aminoácidos y proteínas'",
        HaifaStimHumiK: "Mejora la actividad radicular y la absorción de nutrientes",
        HaifaStimVigor: "Fortalece y potencia la resistencia de las plantas frente a estreses abióticos",
        HaifaStimVIM: "Mejora la fertilidad del suelo y la eficiencia en el uso de nutrientes",
        HaifaStimVital: "Mejora el rendimiento de la planta",
        HaifaStimWallUp:
            " 'Mezcla óptima de micronutrientes seleccionados para mejorar la resistencia de las plantas al estrés abiótico: mejora el crecimiento y maximiza el rendimiento'",
        HaifaMicroCombi:
            "Una mezcla estable: soluble en agua y que no genera polvo de quelatos metálicos: hierro: manganeso: cobre: zinc: todos presentes como forma quelada con EDTA'",
        PolyFeedFoliar1:
            " 'Poly-Feed™ Foliar nutre las plantas: satisfaciendo sus necesidades precisas durante las fases críticas de crecimiento para máximos rendimientos y calidad superior.'",
        PolyFeedFoliar2: "Fórmula específica para cada cultivo",
        PolyFeedStim: "combinación única de estimulantes naturales y fertilizantes minerales NPK",
        HaifaBonus:
            "Las fórmulas de fertilizantes con alto contenido de potasio para una aplicación foliar eficaz se basan en el nitrato de potasio Multi-K™ de Haifa.",
    },
};

export default products;
